import { useQuery } from '@tanstack/react-query'
import { BROKE_FLEX_MESSAGE_KEYS } from '../../keys'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'

export default function useQueryGetBrokeFlexPresets() {
	return useQuery({
		queryKey: BROKE_FLEX_MESSAGE_KEYS.PRESETS,
		queryFn: () => BrokeFlexMessageService.getPresets(),
	})
}
